<ion-list mode="ios" lines="none" class="list-content info-sheet-modal-content">
  <!-- ! Header -->
  <ion-item mode="md" lines="none" color="getm-neutral-white">
    <ion-label color="getm-neutral-dark" class="title">
      {{ 'Titles.' + (promo.Bonificacion ? 'bonus' : 'promotions') | translate
      }}
    </ion-label>

    <ion-button
      shape="round"
      mode="ios"
      slot="end"
      class="button-close"
      color="getm-neutral-selected"
      (click)="onClose()"
    >
      <ion-icon
        slot="icon-only"
        name="close-outline"
        color="getm-neutral-dark"
      ></ion-icon>
    </ion-button>
  </ion-item>

  <!-- ! Mecánica Detallada por Tipo de Promoción -->
  <ng-container [ngSwitch]="promo.TipoPromocion">
    <!-- * ESCALERA -->
    <ng-container *ngSwitchCase="'ESCALERA'">
      <ion-item mode="md" color="transparent" lines="none">
        <ion-label color="getm-neutral-dark" class="label-header">
          {{ 'Labels.add-more-save-more' | translate }}
        </ion-label>
      </ion-item>
      <ion-item mode="md" color="transparent" lines="none">
        <ion-label
          color="getm-neutral-light"
          class="label-content"
          [innerHtml]=" 'Labels.discount-according-to-quantity' | translate | htmlSeguro"
        >
        </ion-label>
      </ion-item>

      <ion-item mode="md" color="transparent" lines="none">
        <section slot="start" class="tag-container">
          <getm-tag-card-img
            icon="getm-information-outline"
            iconColor="getm-primary-default"
            shape="round"
            size="large"
            fill="solid"
            color="getm-background-light-blue"
          ></getm-tag-card-img>
        </section>
        <ion-label color="getm-neutral-dark" class="label-header">
          {{ 'Labels.how-does-it-work' | translate }}
        </ion-label>
      </ion-item>
      <ion-item mode="md" color="transparent" lines="none">
        <ion-label
          color="getm-neutral-light"
          class="label-content"
          [innerHtml]=" 'Labels.how-does-it-work-text' | translate | htmlSeguro"
        >
        </ion-label>
      </ion-item>

      <ion-item mode="md" color="transparent" lines="none">
        <section slot="start" class="tag-container">
          <getm-tag-card-img
            icon="getm-information-outline"
            iconColor="getm-primary-default"
            shape="round"
            size="large"
            fill="solid"
            color="getm-background-light-blue"
          ></getm-tag-card-img>
        </section>
        <ion-label color="getm-neutral-dark" class="label-header">
          {{ 'Labels.available-promotions' | translate }}
        </ion-label>
      </ion-item>
      <ion-item mode="md" color="transparent" lines="none">
        <ion-label
          color="getm-neutral-light"
          class="label-content"
          [innerHtml]=" 'Labels.available-promotions-text' | translate | htmlSeguro"
        >
        </ion-label>
      </ion-item>
    </ng-container>

    <!-- * DINAMICO -->
    <ng-container *ngSwitchCase="'DINAMICO'">
      <ion-item mode="md" color="transparent" lines="none">
        <ion-label color="getm-neutral-dark" class="label-header">
          {{ 'Labels.build-your-promotion-and-save' | translate }}
        </ion-label>
      </ion-item>
      <ion-item mode="md" color="transparent" lines="none">
        <ion-label
          color="getm-neutral-light"
          class="label-content"
          [innerHtml]=" 'Labels.configure-your-promotion' | translate | htmlSeguro"
        >
        </ion-label>
      </ion-item>

      <ion-item mode="md" color="transparent" lines="none">
        <section slot="start" class="tag-container">
          <getm-tag-card-img
            icon="getm-information-outline"
            iconColor="getm-primary-default"
            shape="round"
            size="large"
            fill="solid"
            color="getm-background-light-blue"
          ></getm-tag-card-img>
        </section>
        <ion-label color="getm-neutral-dark" class="label-header">
          {{ 'Labels.how-does-it-work' | translate }}
        </ion-label>
      </ion-item>
      <ion-item mode="md" color="transparent" lines="none">
        <ion-label
          color="getm-neutral-light"
          class="label-content"
          [innerHtml]=" 'Labels.how-does-it-work-text-2' | translate | htmlSeguro"
        >
        </ion-label>
      </ion-item>

      <ion-item mode="md" color="transparent" lines="none">
        <section slot="start" class="tag-container">
          <getm-tag-card-img
            icon="getm-information-outline"
            iconColor="getm-primary-default"
            shape="round"
            size="large"
            fill="solid"
            color="getm-background-light-blue"
          ></getm-tag-card-img>
        </section>
        <ion-label color="getm-neutral-dark" class="label-header">
          {{ 'Labels.available-promotions' | translate }}
        </ion-label>
      </ion-item>
      <ion-item mode="md" color="transparent" lines="none">
        <ion-label
          color="getm-neutral-light"
          class="label-content"
          [innerHtml]=" 'Labels.available-promotions-text-2' | translate | htmlSeguro"
        >
        </ion-label>
      </ion-item>
    </ng-container>

    <!-- * BONIFICACION -->
    <ng-container *ngSwitchCase="'BONIFICACION'">
      <ion-item mode="md" color="transparent" lines="none">
        <ion-label color="getm-neutral-light" class="product-will-be-added">
          {{ 'Labels.product-will-be-added' | translate }}
        </ion-label>
      </ion-item>
    </ng-container>
  </ng-container>

  <!-- ! Actions -->
  <ion-item mode="md" color="transparent" lines="none">
    <getm-button
      [text]="'Buttons.enderstood' | translate"
      color="tertiary"
      size="default"
      expand="block"
      (btnClick)="onClose()"
    ></getm-button>
  </ion-item>
</ion-list>
